import { render, staticRenderFns } from "./FooterTrustSealsBest.vue?vue&type=template&id=759a4f9c"
import script from "./FooterTrustSealsBest.vue?vue&type=script&lang=js"
export * from "./FooterTrustSealsBest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports